import qs from 'query-string';
import React, { FC, useEffect, useState } from 'react';
import { animateScrollTop } from '../../../helpers/scrollToTop/animateScrollTop';
import { getHashParam } from '../../../helpers/url/urlHelpers';
import IArticleModel from '../../../interfaces/articles/articleModel';
import Pager from '../../pager/pager';
import ArticleList from '../articleList';
import * as StyledArticlesOverview from './articlesOverview.styles';

import { numberOfBlogsAndArticles } from '../../../constants/articles/pageSize';

// @ts-ignore
interface OptionValue {
	label: string;
	value: string;
}

const setHashParams = (page: number) => {
	const searchString = qs.stringify({
		page,
	});

	window.location.hash = searchString;
};

// Workaround: Remove Ársskýrsla category from the list, because we only want to show articles in this category in News ContentSlices
// where the CategoryFilter is set specifically to Ársskýrsla, we don't want to show articles in this category anywhere else on the site
export const ANNUAL_REPORTS_CATEGORY = 'Ársskýrsla';

const ArticlesOverview: FC = () => {
	const queryPage = getHashParam('page');

	const initialPage = queryPage ? Number(queryPage) : 1;
	const activeCategoryId = 1;
	const [activePage, setActivePage]: [number, any] = useState(initialPage);
	const [allArticles, setArticleData] = useState<IArticleModel>(undefined);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchAllArticles(activePage, numberOfBlogsAndArticles);

		setHashParams(activePage);
	}, [activeCategoryId, activePage]);

	const fetchAllArticles = async (page: number, pageSize?: number) => {
		let query = '/api/articles';

		query += `?page=${page}`;

		if (pageSize) query += `&pageSize=${pageSize}`;

		const response = await fetch(query).then(response => response.json());
		const filteredArticles = response.Items.filter(article => !article.Category.includes(ANNUAL_REPORTS_CATEGORY));

		setArticleData({ ...response, Items: filteredArticles });

		setLoading(false);
	};

	const setPage = (p: number) => {
		animateScrollTop();
		setActivePage(p);
	};

	const onPageClick = pageNumber => {
		setPage(pageNumber);
	};

	return (
		<StyledArticlesOverview.Wrapper>
			<ArticleList
				articles={allArticles ? allArticles.Items : []}
				loading={loading}
				error={false}
				category={activeCategoryId}
				paddingOff
			/>
			{allArticles && allArticles.TotalPages > 1 && (
				<Pager pageCount={allArticles.TotalPages} activePage={activePage} onClick={onPageClick} />
			)}
		</StyledArticlesOverview.Wrapper>
	);
};

export default ArticlesOverview;
